/// <amd-module name="Test/TestCaseResults/Redux/TestCaseResultsContracts" />
import { IListBoxItemData } from "Test/TestCaseResultsFilter/TestCaseResultsFilterComponent.Types";
import * as Contracts from "TestPlanCommon/Contracts/TestPlan";
import { ObservableArray } from "VSS/Core/Observable";
import { IListBoxItem } from "VSSUI/ListBox";

export interface ITestCaseResultsAwareState {
    testCaseResultsState: ITestCaseResultsState;
    testCaseResultsFilterState: ITestCaseResultsFilterState;
}

export interface ITestCaseResultsState {
    testCaseName: string;
    testCaseResults: Contracts.TestCaseAssociatedResult[];
    contextPoint: Contracts.TestPointDetailedReference;
    // Column widths of the execution history table
    columnAndWidthMap: { [columnId: string]: number };
}

export interface ITestCaseResultsFilterState {
    filteredResultIds?: IRunDetailsItem[];
}

export interface ITestPointConfiguration {
    id: number;
    name: string;
}

export interface IRunDetailsItem {
    pointId: number;
    runId: number;
    resultId: number;
}

export interface ITestCaseResultsFilterValues {
    outcome: ObservableArray<IListBoxItem<IListBoxItemData>>;
    tester: ObservableArray<IListBoxItem<IListBoxItemData>>;
    configuration: ObservableArray<IListBoxItem<IListBoxItemData>>;
    plan: ObservableArray<IListBoxItem<IListBoxItemData>>;
    suite: ObservableArray<IListBoxItem<IListBoxItemData>>;
}
